import { isFeatureEnabled } from '@luna/gatekeeper';
import { isInWebView } from '@shared/george-go';
import type { BankMessage } from '@shared/bank-messages-utils';
import { BankMessageFlag } from '@shared/bank-messages-utils';

export const filterUnreadMessages = (messages: BankMessage[] = []): BankMessage[] =>
    messages.filter(({ flags }) => flags?.includes(BankMessageFlag.UNREAD));

export const removeMessageFromArray = (
    messages: BankMessage[],
    messageId: string,
): BankMessage[] => {
    return messages.filter(({ id }) => id !== messageId);
};

export const areMustReadMessagesEnabled = (): boolean =>
    isFeatureEnabled((f) => f.mustReadMessages) && !isInWebView();
